import React, { forwardRef } from 'react';
import Copy from "./copy";
import useStyles from "./style";
var addPrefixSuffix = function addPrefixSuffix(str, chain) {
  if (!str) return str;
  var resStr = str;
  var prefix = 'ELF_';
  var suffix = "_".concat(chain);
  if (!str.startsWith(prefix)) {
    resStr = "".concat(prefix).concat(resStr);
  }
  if (!str.endsWith(suffix)) {
    resStr = "".concat(resStr).concat(suffix);
  }
  return resStr;
};
var getOmittedStr = function getOmittedStr(str, preLen, endLen) {
  if (!str || typeof str !== 'string') {
    return str;
  }
  if (typeof preLen !== 'number' || typeof endLen !== 'number') {
    return str;
  }
  if (str.length <= preLen + endLen) {
    return str;
  }
  if (preLen === 0 || endLen === 0) {
    return str;
  }
  return "".concat(str.slice(0, preLen), "...").concat(str.slice(-endLen));
};
var Address = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var address = _ref.address,
    _ref$chain = _ref.chain,
    chain = _ref$chain === void 0 ? 'AELF' : _ref$chain,
    _ref$preLen = _ref.preLen,
    preLen = _ref$preLen === void 0 ? 0 : _ref$preLen,
    _ref$endLen = _ref.endLen,
    endLen = _ref$endLen === void 0 ? 0 : _ref$endLen,
    _ref$hasCopy = _ref.hasCopy,
    hasCopy = _ref$hasCopy === void 0 ? true : _ref$hasCopy,
    addressClickCallback = _ref.addressClickCallback,
    className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'default' : _ref$size,
    _ref$ignorePrefixSuff = _ref.ignorePrefixSuffix,
    ignorePrefixSuffix = _ref$ignorePrefixSuff === void 0 ? false : _ref$ignorePrefixSuff,
    _ref$ignoreEvent = _ref.ignoreEvent,
    ignoreEvent = _ref$ignoreEvent === void 0 ? false : _ref$ignoreEvent,
    primaryLinkColor = _ref.primaryLinkColor,
    primaryIconColor = _ref.primaryIconColor,
    addressHoverColor = _ref.addressHoverColor,
    addressActiveColor = _ref.addressActiveColor;
  var _useStyles = useStyles({
      size: size,
      ignoreEvent: ignoreEvent,
      primaryLinkColor: primaryLinkColor,
      primaryIconColor: primaryIconColor,
      addressHoverColor: addressHoverColor,
      addressActiveColor: addressActiveColor
    }),
    st = _useStyles.styles,
    cx = _useStyles.cx,
    prefixCls = _useStyles.prefixCls;
  var addPrefixSuffixTxt = ignorePrefixSuffix ? address : addPrefixSuffix(address, chain);
  var omittedStr = getOmittedStr(addPrefixSuffixTxt, preLen, endLen);
  var addressClickHandler = function addressClickHandler(e) {
    if (ignoreEvent) {
      return;
    }
    if (addressClickCallback) {
      addressClickCallback(address, addPrefixSuffixTxt, e);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cx(st.addressWrap, className, prefixCls + '-hash-address'),
    ref: ref
  }, /*#__PURE__*/React.createElement("span", {
    className: st.addressText,
    onClick: addressClickHandler
  }, omittedStr), hasCopy && /*#__PURE__*/React.createElement("div", {
    className: st.copyBtnWrap
  }, /*#__PURE__*/React.createElement(Copy, {
    className: st.copyBtn,
    value: addPrefixSuffixTxt
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Address.displayName = 'Address';
}
export default Address;